import Navbar  from "../components/NavBar/NavBar.js";

const Sosiété = () =>{
    return(
        <div className="body">
            <Navbar/><br/><br/><br/><br/><br/>
            <h1><center>Partenaires</center></h1>
        </div>    
    )
};

export default Sosiété;